var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ArrayMaxSize, IsArray, IsOptional, IsString, MaxLength } from 'class-validator';
/**
 * Body for minting a fresh embed key. Allowed origins are optional at
 * creation — a practice can create the key first and paste the widget's real
 * domain(s) in afterwards. Until at least one origin is listed the widget
 * cannot boot (the session exchange refuses an origin that is not on the
 * allowlist), which is the safe default.
 */
export class CreateEmbedKeyDto {
    allowedOrigins;
}
__decorate([
    IsOptional(),
    IsArray(),
    ArrayMaxSize(50),
    IsString({ each: true }),
    MaxLength(255, { each: true }),
    __metadata("design:type", Array)
], CreateEmbedKeyDto.prototype, "allowedOrigins", void 0);
//# sourceMappingURL=create-embed-key.dto.js.map